/// <reference path="../../../../../shared/utils/Helper.ts"/>

import { AppApiService } from "./AppApiService";
import { ContractInfoApi } from "../../../../../shared/models/generated/PersonContractInfoApi";
import { AppPersistenceService } from "./AppPersistenceService";
import { AppViewService } from "./AppViewService";
import { TimeService } from "../../../../../shared/services/TimeService";
import { AppApplicationService } from "./AppApplicationService";
import { AppModelAdapter } from "../helper/AppModelAdapter";

export class AppRateService {
	private readonly options: MglModularSystemV2AppOptions;
	private readonly appApiService: AppApiService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appViewService: AppViewService;
	private readonly timeService: TimeService;
	private readonly appApplicationService: AppApplicationService;

	constructor(options: MglModularSystemV2AppOptions) {
		this.options = options;

		this.appApiService = new AppApiService(options);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(options, undefined);
		this.appApplicationService = new AppApplicationService(options);
		this.timeService = new TimeService();
	}

	public updateRate(isCheckPage = false): void {
		const options = this.getRateCallOptions(isCheckPage);
		this.appApiService.makeRateRequest(
			options,
			this.handleRateRequestSuccess.bind(this),
			() => {
				//NOSONAR
			}
		);
	}

	public rateUpdateForValidation(successCallback: (data: ApiResponse<ContractInfoApi>, textStatus?: string, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): void {
		const options = this.getRateCallOptions();
		this.appApiService.makeRateRequest(
			options,
			this.updateForValidationRequestSuccess.bind(this, successCallback),
			errorCallback
		);
	}

	private updateForValidationRequestSuccess(cb: (data: ApiResponse<ContractInfoApi>) => void, data: ApiResponse<ContractInfoApi>): void {
		this.handleRateRequestSuccess(data);
		cb(data);
	}

	/**
	 * Handle a succeded rateCall
	 * called also from BasicValidationService
	 */
	private handleRateRequestSuccess(successData: ApiResponse<ContractInfoApi>): void {
		const mglApp = this.appPersistenceService.getApplicationModel();

		if (mglApp) {
			mglApp.Tarif = successData.Data;
			this.appPersistenceService.setApplicationModel(mglApp);

			let juvs = 0;
			let childs = 0;
			for (const child of mglApp.FormModel.Kinder) {
				if (child.IsJuv) {
					juvs++;
				} else {
					childs++;
				}
			}

			const rateoptions: { youngadultscount: number, numberOfChildren: number, showchildrennote?: boolean, hasPartner: boolean, isThirdPartyForm?: boolean } = {
				youngadultscount: juvs,
				numberOfChildren: childs,
				hasPartner: mglApp.Tarif.HatPartner,
				isThirdPartyForm: this.options.app.isthirdpartyform
			};

			this.appViewService.updateRateDebendentContent(mglApp.Tarif, rateoptions);
			this.appViewService.updateDiscountDebendentContent();
		}
	}

	// @todo merge with other copies of getRateCallOptions into shared ModelAdapter and use generated model from https://ei-b-apil-mockup.adac.biz/Help/Api/GET-api-MglTarif
	private getRateCallOptions(isCheckPage = false): object {
		const formModel = this.appPersistenceService.getFormModelFromStore();
		const options = {
			data: {
				Tarif: this.options.app.rate || 1
			} as { [key: string]: any }
		};

		const fake17 = this.appApplicationService.isYoungGenerationRate(this.options.app.rate) && this.options.app.apiinitialbirthdayfakeunder18;
		let geburtsdatumAntragsteller = this.appViewService.getGeburtsdatumAntragsteller();
		if (geburtsdatumAntragsteller === undefined && formModel.Antragssteller) {
			geburtsdatumAntragsteller = formModel.Antragssteller.Geburtsdatum;
		}
		options.data.GeburtstagMitglied = geburtsdatumAntragsteller && geburtsdatumAntragsteller !== "" ? this.timeService.formatDate(geburtsdatumAntragsteller) : this.timeService.getDefaultBirthday(fake17 ? 17 : 19);

		if (formModel.Partner) {
			const geburtsdatumPartnerView = this.appViewService.getGeburtsdatumPartner();
			const geburtsdatumPartner = geburtsdatumPartnerView ? geburtsdatumPartnerView : formModel.Partner ? formModel.Partner.PersonalData.Geburtsdatum : "";
			options.data.GeburtstagPartner = geburtsdatumPartner && geburtsdatumPartner !== "" ? this.timeService.formatDate(geburtsdatumPartner) : this.timeService.getDefaultBirthday(19);
		}

		if (isCheckPage) {
			options.data.GeburtstageKinder = AppModelAdapter.getKinderGeburtstagsArrayV2(formModel.Kinder, this.appViewService.getChildCount(), this.appViewService.getJuvCount());
		} else {
			options.data.GeburtstageKinder = AppModelAdapter.getKinderGeburtstagsArrayV2(this.appViewService.getChildDataModel(), this.appViewService.getChildCount(), this.appViewService.getJuvCount());
		}

		options.data.InAusbildung = formModel.InAusbildung;
		options.data.Schwerbehindert = formModel.IstSchwerbehindert;

		return options;
	}

}
